import { useHistory } from "react-router-dom";

import useQuery from "hooks/useQuery";

import {
    DEFAULT_MENU_SETTINGS_TAB,
    MENU_SETTINGS_TABS,
} from "features/MenuSettings/constants";
import { MenuSettingsTab } from "features/MenuSettings/types";

const isSettingsTab = (value: string | undefined): value is MenuSettingsTab =>
    MENU_SETTINGS_TABS.some((tab) => tab.key === value);

// Активный таб живёт в ?tab=; пишем через replace, чтобы «назад» браузера не листал табы.
export const useActiveTab = (): [MenuSettingsTab, (tab: MenuSettingsTab) => void] => {
    const history = useHistory();
    const { tab } = useQuery<{ tab?: string }>();

    const activeTab: MenuSettingsTab = isSettingsTab(tab)
        ? tab
        : DEFAULT_MENU_SETTINGS_TAB;

    const setActiveTab = (next: MenuSettingsTab) => {
        const params = new URLSearchParams(history.location.search);
        params.set("tab", next);
        history.replace({ search: params.toString() });
    };

    return [activeTab, setActiveTab];
};
